<style lang="scss">
.zoezi-workout-dialog {
  .zoezi-booked-list {
        border-top: solid 1px rgba(0, 0, 0, .1);
        width: 100%;
        flex-shrink: 0;
    }
    .list .item .zoezi-booked-list .zoezi-booked-person{
        border-bottom: solid 1px rgba(0,0,0,.1);
    }
    .list .item .zoezi-booked-list .zoezi-booked-person:last-child{
        border-bottom:none;
    }
}
</style>

<template>
    <v-dialog
        v-model="showWorkoutDialog"
        max-width="850"
        scrollable
    >

        <v-card v-if="workout">
            <dialog-header :title="workout.workoutType.name + (workout.extra_title ? ' - ' + workout.extra_title : '')" :image="image" @close="showWorkoutDialog = false" />

            <v-card-text class="overflow-y-auto">
                <v-row>
                    <v-col cols="8">
                        <v-row no-gutters>
                            <v-col cols="auto">
                                <v-icon color="primary">mdi-calendar</v-icon> {{formatStartDate(workout.startTime)}} {{formatStartTime(workout.startTime)}}
                            </v-col>

                            <v-col cols=6 v-if="workout.resources && workout.resources.length">
                                <span class="zoezi-clickable">
                                    <v-icon color="primary">mdi-map-marker</v-icon>
                                    <span v-for="(r,index) in workout.resources" :key="r.id">
                                        <a v-if="r.position" href="" class="primary--text z-no-underline" @click.prevent="doShowMapDialog(r)">{{r.name}}</a>
                                        <span v-else>{{r.name}}</span>
                                        <span v-if="index != workout.resources.length-1">,&nbsp;</span>
                                    </span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols=12>
                                <div v-if="workout.workoutType.description || workout.description" v-safe-html="workout.description || workout.workoutType.description" />
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="4" class="text-right" v-if="showNumBooked">
                        <v-progress-circular
                            v-if="workout.space && !workout.isCancelled()"
                            :rotate="-90"
                            :size="100"
                            :width="15"
                            :value="workoutBookedPercent"
                            :color="workoutBookedPercent >= 80 ? 'error' : (workoutBookedPercent >= 60 ? 'warning' : 'primary')"
                        >
                            <span style="text-align: center" v-if="workoutRemainingPlaces > 0">{{workoutRemainingPlaces}}<br>{{$translate('PLACES')}}<br>{{$translate('left')}}</span>
                            <span style="text-align: center" v-else-if="workoutRemainingPlaces == 0 && workout.numQueue == 0">{{$translate('Full')}}</span>
                            <span style="text-align: center" v-else-if="workout.numQueue > 0">{{workout.numQueue}}<br>{{$translate('in queue')}}</span>
                        </v-progress-circular>
                    </v-col>
                </v-row>

                <div v-for="staff in computedStaffs" :key="staff.id" class="d-inline-block mr-4">
                    <!--_FIXME: zoezi-user-avatar  -->
                    <v-avatar left size="50" class="mr-2">
                        <v-auto-img :src="staff.imagekey || '/assets/img/profile_avatar_man.jpg'" :key="staff.imagekey" />
                    </v-avatar>
                    <a href="" class="primary--text z-no-underline" @click.prevent="doShowStaffInfoDialog(staff)">{{staff.name}}</a>
                </div>

                <Invite v-if="invite" :workout="workout" :invite="invite"></Invite>

                <v-tabs>
                    <v-tab v-if="discussionEnabled">
                        <span class="tab-title">{{$translate('Discussion')}}</span><v-badge v-if="messageCount" color="primary" :content="messageCount" class="ml-2" />
                    </v-tab>
                    <v-tab v-if="filteredBookings.coming.length">
                        <span class="tab-title">{{$translate('Coming')}}</span><v-badge color="success" :content="filteredBookings.coming.length" class="ml-2" />
                    </v-tab>
                    <v-tab v-if="filteredBookings.no.length">
                        <span class="tab-title">{{$translate('No')}}</span><v-badge color="error" :content="filteredBookings.no.length" class="ml-2" />
                    </v-tab>
                    <v-tab v-if="filteredBookings.noAnswer.length">
                        <span class="tab-title">{{$translate('No answer')}}</span><v-badge color="warning" :content="filteredBookings.noAnswer.length" class="ml-2" />
                    </v-tab>
                    <v-tab-item v-if="discussionEnabled">
                        <workout-discussion :workout="workout" class="mt-8" @count="messageCount=$event" />
                    </v-tab-item>
                    <v-tab-item v-if="filteredBookings.coming.length">
                        <member-list :members="filteredBookings.coming" />
                    </v-tab-item>
                    <v-tab-item v-if="filteredBookings.no.length">
                        <member-list :members="filteredBookings.no" />
                    </v-tab-item>
                    <v-tab-item v-if="filteredBookings.noAnswer.length">
                        <member-list :members="filteredBookings.noAnswer" />
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-card-actions v-if="!$store.state.cards && $store.state.user">
                <v-row justify="center">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        class="mb-4"
                    ></v-progress-circular>
                </v-row>
            </v-card-actions>
            <v-card-actions v-else-if="matchRequiresMembership">
                <div class="d-flex flex-column fill-width">
                    <v-alert type="info">{{$translate('In order to book this activity you need to have a membership')}}</v-alert>

                    <v-btn block color="primary" @click="showMembershipDialog = true">{{$translate('Buy membership')}} </v-btn>
                </div>
            </v-card-actions>
            <v-card-actions style="flex-wrap: wrap;" v-else>
                <div class="font-weight-bold" v-if="workout.isCancelled()">{{$translate('The workout is cancelled')}}</div>

                <template>
                    <workout-book-button v-if="(tooEarlyOrTooLate && !allBooked) || (canOnlyBookForSelf && workout.getState() == 'bookbuy')" :workout="workout" :show-extra-info="true" :showNumBooked="showNumBooked" :block="true" class="fill-width" />
                    <template>

                        <div class="zoezi-booked-list" v-if="$store.state.user" style="flex-shrink: 0; width: 100%" :data-these-can-book-text="$translate('These can book')">
                            <workout-book-user-row
                                class="zoezi-booked-person"
                                :workout="workout"
                                :user="user"
                                v-for="user in $store.state.user.canBookFor.filter(x => (canOnlyBookForSelf || !isNoBook(x)) && (!tooEarlyOrTooLate || workout.isBooked(x) ))"
                                :key="user.id"
                            />
                        </div>

                        <v-expansion-panels v-if="!canOnlyBookForSelf && noBookPersons && noBookPersons.length">
                            <v-expansion-panel>
                                <v-expansion-panel-header class="pa-0">
                                    <div class="pa-2 d-flex">
                                        <div class="d-flex align-center">
                                            <v-icon color="primary">mdi-account-multiple</v-icon>
                                        </div>
                                        <div class="ml-2 flex-grow-1">
                                            {{$translate('These cannot book')}}
                                        </div>
                                    </div>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="pa-0">

                                    <workout-book-user-row
                                        class="zoezi-booked-person"
                                        :workout="workout"
                                        :user="user"
                                        v-for="user in noBookPersons"
                                        :key="user.id"
                                    />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </template>
                </template>
            </v-card-actions>
        </v-card>

        <staff-info-dialog v-model="showStaffInfoDialog" :staffId="showStaff.id" v-if="showStaff" />

        <map-dialog v-model="showMapDialog" :resource="showMap" v-if="showMap" />

        <BuyMembershipDialog v-model="showMembershipDialog" v-if="showMembershipDialog" />
    </v-dialog>

</template>

<script>
import DialogHeader from './DialogHeader.vue';
import WorkoutBookButton from './WorkoutBookButton.vue';
import WorkoutBookUserRow from './WorkoutBookUserRow.vue'
import WorkoutDiscussion from './WorkoutDiscussion.vue'
import MemberList from './MemberList.vue'
import StaffInfoDialog from './StaffInfoDialog.vue'
import MapDialog from './MapDialog.vue'
import Invite from './Invite.vue'
import * as Sentry from '@sentry/browser'
import BuyMembershipDialog from './BuyMembershipDialog.vue'

export default {
    name: 'zoezi-workout-dialog',
    props: {
        workout: {
            type: Object
        },
        value: {
            type: Boolean
        },
        showNumBooked: {
            type: Boolean,
            default: true
        },
        invite: {
            type: Object
        },
        showLastnameForInstructors: {
            type: Boolean,
            default: false
        }
    },

    components: {
        WorkoutBookUserRow,
        WorkoutBookButton,
        DialogHeader,
        WorkoutDiscussion,
        MemberList,
        StaffInfoDialog,
        MapDialog,
        Invite,
        BuyMembershipDialog
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showWorkoutDialog = value;
            }
        },
        showWorkoutDialog(value) {
            this.$emit('input', value);
        },
        workout: {
            immediate: true,
            handler(workout) {
                if (workout) {
                    this.unsubscribeAll();
                    this.unsubscribe.push(this.$root.$api.subscribe({type: 'workoutbooking', callback: (_, event) => {
                        event.data.forEach(item => {
                            // Update numBooked and numQueue for workout
                            if (item.workout == workout.id) {
                                workout.numBooked = item.numBooked;
                                workout.numQueue = item.numQueue;
                                this.getBookings();
                            }
                        })
                    }}));

                    this.unsubscribe.push(this.$root.$api.subscribe({type: 'workout', callback: (_, event) => {
                        event.data.forEach(item => {
                            if (item.id == workout.id) {
                                Object.assign(workout, item)
                                this.$booking.transformWorkout(workout)
                            }
                        })
                    }}))

                    this.unsubscribe.push(this.$root.$api.subscribe({type: 'workoutbookinginvite', callback: (_, event) => {
                        event.data.forEach(item => {
                            if (item.workout_id == workout.id) {
                                this.getBookings();
                            }
                        })
                    }}))
                }
            }
        }
    },
    data: () => ({
        showWorkoutDialog : false,
        loading: false,
        unsubscribe: [],
        bookings: [],
        messageCount: 0,
        showStaffInfoDialog: false,
        showStaff: null,
        showMapDialog: false,
        showMap: null,
        showMembershipDialog: false
    }),
    computed: {
        computedStaffs() {
            return this.workout.staffs.map(staff => {
                return {
                    ...staff,
                    name: this.showLastnameForInstructors ? `${staff.firstname} ${staff.lastname}` : `${staff.firstname} ${staff.lastname.substring(0, 1)}`
                }
            })
        },
        image() {
            if (this.workout.workoutType.imagekey) {
                return this.workout.workoutType.imagekey;
            } else {
                return '/api/image/get?type=Logo&id=1'
            }
        },
        canOnlyBookForSelf() {
            return this.$store.state.user?.canBookFor.length == 1 && this.$store.state.user.canBookFor[0].id == this.$store.state.user.id;
        },
        noBookPersons() {
            return this.$store.state.user?.canBookFor?.filter(u => this.isNoBook(u));
        },
        tooEarlyOrTooLate() {
            return this.workout.tooEarlyToBook() || this.workout.tooLateToBook() || !this.workout.bookableForCustomer;
        },
        allBooked() {
            return this.$store.state.user?.canBookFor.every(user => this.workout.isBooked(user));
        },
        discussionEnabled() {
            return this.workout.discussionEnabled();
        },
        showMembersEnabled() {
            return this.workout.showMembersEnabled();
        },
        filteredBookings() {
            return {
                coming: this.bookings.filter(b => b.booking && !b.inQueue),
                no: this.bookings.filter(b => b.declined),
                noAnswer: this.bookings.filter(b => b.invited && !b.booking && !b.declined)
            }
        },
        matchRequiresMembership() {
            return this.workout.isMatchWhichRequiresMembership();
        },
        workoutBookedPercent() {
            if (!this.workout.space) return 0;
            return 100 * (this.workout.numBooked - this.workout.numQueue) / this.workout.space;
        },
        workoutRemainingPlaces() {
            return Math.max(0, this.workout.space - (this.workout.numBooked - this.workout.numQueue));
        }
    },
    methods: {
        // FIXME: Move to central place
        formatStartDate(time) {
            let date = Date.newFull(time);
            var ft = this.$store.state.now30s.clone().clearTime().daysUntil(date);
            if (ft > 6 || ft < 0 || date.getWeekNumber() > new Date().getWeekNumber()) {
                return date.yyyymmdd();
            } else {
                let res = [];
                if (ft == 0) {
                    res = ['Today'];
                } else if (ft == 1) {
                    res = ['Tomorrow', date.getWeekDayString()];
                } else {
                    res = [date.getWeekDayString()];
                }

                return res.map(this.$translate).join(' ');
            }
        },
        formatStartTime(time) {
            return Date.newFull(time).hhmm();
        },
        unsubscribeAll() {
            this.unsubscribe.forEach(u => u?.());
            this.unsubscribe = [];
        },
        isNoBook(user) {
            return ['nobook', 'bookbuy', 'queuebuy'].includes(this.workout.getState(user));
        },
        getBookings() {
            if (this.showMembersEnabled) {
                this.$api.get('/api/memberapi/workout/bookings/get', {id: this.workout.id}).then(bookings => this.bookings = bookings);
            }
        },
        doShowStaffInfoDialog(staff) {
            this.showStaffInfoDialog = true;
            this.showStaff = staff;
        },
        doShowMapDialog(resource) {
            this.showMapDialog = true;
            this.showMap = resource;
        }
    },
    mounted() {
        this.getBookings();

        try {
            let ecommerceTrackingItem = {
                id: 'w' + this.workout.id,
                name: this.workout?.workoutType?.name,
                price: this.workout?.workoutType?.price,
                vat: this.workout?.workoutType?.vat,
            };
            this.$ecommercetracking.viewItem(ecommerceTrackingItem);
        } catch(error) {
            Sentry.captureException(error);
        }
    },
    destroy() {
        this.unsubscribeAll();
    }
}
</script>
